import React, { useCallback, useContext, useEffect, useState } from "react";
import "./Header.styles.scss";
import {
  PowerSettingsNewRounded,
  HelpOutlineRounded,
} from "@mui/icons-material";
import {
  TooltipProps,
  Tooltip,
  tooltipClasses,
  IconButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Badge,
  CircularProgress,
  Grow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { toggleSidebar } from "@/store/reducers/sidebar/sidebar.actions";
import { persistor, store, useAppDispatch } from "@/store";
import { useLocation, useNavigate } from "react-router-dom";
import { routePaths } from "@/config";
import CModal from "@/components/Modal/Modal";
import { InlineIcon } from "@iconify/react";
import { getToken } from "@/store/reducers/member/member.actions";
import {
  selectIsModerationSuspend,
  selectModerationSocket,
  selectNbreLiveSocket,
  selectNbreNotificationSocket,
} from "@/store/reducers/general_param/general_param.selector";
import { ConnectedProps, connect, useSelector } from "react-redux";
import { createStructuredSelector } from "reselect";
import { TModerationSocket, TUserConnected } from "../../types";
import CModalInfosZawaj from "@/components/Modal-Infos-Zawaj/ModalInfosZawaj";
import { AppSocketContext } from "@/routes";
import { socketChannels } from "@/config/socketChannels";
import { updateIsModerationSuspend } from "@/store/reducers/general_param/general_param.actions";
import { axios } from "@/lib/axios";
import {
  selectMessageNotif,
  selectFavoriteNotif,
  selectExchangeNotif,
  selectMouqabalaNotif,
} from "@/store/reducers/member/member.selector";
import { TMouqabalaCard } from "../../Elements/MouqabalaCard/MouqabalaCard";
import useExchangeRole from "@/hooks/useExchangeRole";
import {
  apiGetMouqabalaInfos,
  apiMouqabalaAccept,
  apiMouqabalaDeny,
} from "../../api/mouqabala.api";
import { Toastify } from "@/utils/toast";
import LoaderMini from "@/components/Loader-mini/LoaderMini";
import ModalCreneau from "@/components/Modal-creneau/ModalCreneau";
import * as moment from "moment";
import "moment/locale/fr";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    boxShadow: `0 0 0 2px ${theme.palette.secondary}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

type HeaderProps = {
  title: string;
  subtitle: string;
};
const Header = ({ title, subtitle }: HeaderProps) => {
  const nbre_message_notif = useSelector(selectMessageNotif);
  const nbre_favorite_notif = useSelector(selectFavoriteNotif);
  const nbre_exchange_notif = useSelector(selectExchangeNotif);
  const nbre_live_notif = useSelector(selectNbreLiveSocket);
  const nbre_mouqabala_notif = useSelector(selectMouqabalaNotif);
  const nbre_notification = useSelector(selectNbreNotificationSocket);
  const moderation_socket = useSelector(selectModerationSocket);

  const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
    },
  }));

  const [openInfos, setOpenInfos] = useState(false);
  const handleOpenInfos = () => setOpenInfos(true);
  const handleCloseInfos = () => setOpenInfos(false);

  const [openHelp, setOpenHelp] = useState(false);
  const handleOpenHelp = () => setOpenHelp(true);
  const handleCloseHelp = () => setOpenHelp(false);

  const [openModeration, setOpenModeration] = useState(false);
  const handleOpenModeration = () => setOpenModeration(true);
  const handleCloseModeration = () => setOpenModeration(false);

  const [openLogout, setOpenLogout] = useState(false);
  const handleClickOpenLogout = () => setOpenLogout(true);
  const handleCloseLogout = () => setOpenLogout(false);

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { socketIO, socketRef } = useContext(AppSocketContext);

  const [isModerationOpen, setIsModerationOpen] = useState(false);

  const logout = () => {
    axios
      .post("/auth-s/api/v1/auth/logout")
      .then(() => {})
      .catch(() => {})
      .finally(() => {
        store.dispatch({ type: "CLEAR_STORE" });
        localStorage.clear();
        navigate(routePaths.auth, { replace: true });
        dispatch(getToken(""));
        persistor.purge();

        console.log("✅ socketRef.current avant", socketRef.current, socketIO);
        if (socketRef.current) {
          socketRef.current.disconnect();
          socketRef.current = null;
          console.log(
            "✅ socketRef.current après",
            socketRef.current,
            socketIO
          );
        }

        socketIO?.close();
      });
  };

  const goToHome = () => {
    navigate(routePaths.profileChildren.homeAbsolute, { replace: true });
  };

  const getIsModerationOpen = useCallback(() => {
    axios
      .get("/param-s/api/v1/parameters/app-plannings/is-open")
      .then((response: any) => {
        // store.dispatch(updateIsModerationSuspend(response.data.isOpen));
        setIsModerationOpen(response.data);
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    getIsModerationOpen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (socketIO) {
      socketIO.on(socketChannels.is_moderation_open, (data) => {
        console.log("🌍", data);
        // store.dispatch(updateIsModerationSuspend(data.isOpen));
        setIsModerationOpen(data.isOpen);
      });
      socketIO.on(socketChannels.mouqabala_channel, (data) => {
        console.log("Socket Mouqabala ✌️", data);
        const value = data;
        handleNewIncomeMouqabalaInfos(value);
      });
    }
  }, [socketIO]);

  const is_moderation_suspend = useSelector(selectIsModerationSuspend);

  const isModerationReallyAvailable = useCallback((): boolean => {
    console.log(isModerationOpen);
    console.log(is_moderation_suspend);

    if (is_moderation_suspend === true) {
      return false;
    } else {
      if (isModerationOpen === true) {
        return true;
      } else {
        return false;
      }
    }
  }, [isModerationOpen, is_moderation_suspend]);

  const [loading3, setLoading3] = useState(true);
  useEffect(() => {
    setLoading3(true);
    setTimeout(() => {
      setLoading3(false);
    }, 1000);
  }, []);

  /**
   *  MOUQABALA IN HEADER PART
   */

  const {
    isSender,
    isReceiver,
    receiver: receiverFromExchangeRole,
    currentExchange,
  } = useExchangeRole();

  const [mouqInfos, setMouqInfos] = useState<TMouqabalaCard | null>(null);

  const [isMouqShow, setIsMouqShow] = useState(true);
  const toggleIsMouqShow = () => {
    setIsMouqShow((prev) => !prev);
  };

  const manageReceiverStatus = (
    status: string
  ): "not-yet" | "accepted" | "denied" => {
    console.log({ status });
    switch (status) {
      case "ACCEPTED":
        return "accepted";
      case "REJECTED":
        return "denied";
      default:
        return "not-yet";
    }
  };

  const manageSenderStatus = (
    status: string
  ): "not-yet" | "canceled" | "paid" => {
    console.log({ status });
    switch (status) {
      case "CANCELLED":
        return "canceled";
      case "RESERVED":
        return "paid";
      default:
        return "not-yet";
    }
  };

  const handleNewIncomeMouqabalaInfos = (value: any) => {
    console.log({ value });
    const data: TMouqabalaCard = {
      sender: {
        id: value.sender._id,
        username: value.sender.infos.username,
        gender: value.sender.infos.gender,
        stripe_id: value.sender.stripe_id,
        member_id: value.sender.member_id,
      },
      receiver: {
        id: value.receiver._id,
        username: value.receiver.infos.username,
        gender: value.receiver.infos.gender,
        stripe_id: value.receiver.stripe_id,
        member_id: value.receiver.member_id,
      },
      id: value.id,
      conversationId: value.conversationId,
      mouqabala_link: null,
      isMouqabalaPaid: false,
      mouqabalaReceiverAnswer: manageReceiverStatus(value.status),
      mouqabalaSenderAnswer: manageSenderStatus(value.status),
      mouqabala_date: moment
        .default(value?.appointmentSlot?.startTime)
        .format("L"),
      mouqabala_start_time: moment
        .default(value?.appointmentSlot?.startTime)
        .format("HH:mm"),
      mouqabala_end_time: moment
        .default(value?.appointmentSlot?.endTime)
        .format("HH:mm"),
      mouqabala_duration:
        moment
          .default(value?.appointmentSlot?.endTime)
          .diff(value?.appointmentSlot?.startTime, "minutes") + " minutes",
      status: value.status,
      creneau_id: value?.appointmentSlot?.id,
      isNotDemande: !!value?.appointmentSlot,
    };
    console.log({ data });

    setMouqInfos({ ...data }); // <--- test àà enlever après

    //SENDER CASE
    if (isSender) {
      console.log(data.mouqabalaReceiverAnswer);
      if (data.mouqabalaReceiverAnswer === "accepted") {
        setMouqInfos({ ...data });
      } else {
        setMouqInfos(null);
      }
    }
    //End of SENDER CASE

    //RECEIVER CASE
    if (isReceiver) {
      console.log(data.mouqabalaSenderAnswer);
      console.log(data.mouqabalaReceiverAnswer);
      if (
        data.mouqabalaSenderAnswer === "not-yet" &&
        !["accepted", "denied"].includes(data.mouqabalaReceiverAnswer || "")
      ) {
        setMouqInfos({ ...data });
      } else {
        setMouqInfos(null);
      }
    }
    //End of RECEIVER CASE
  };

  // Mock data pour les informations de mouqabala
  const mockMouqabalaInfos = {
    id: "mock1",
    sender: {
      _id: "sender1",
      infos: {
        username: "JohnDoe",
        gender: "MALE",
      },
      stripe_id: "stripe1",
      member_id: "1",
    },
    receiver: {
      _id: "receiver1",
      infos: {
        username: "JaneSmith",
        gender: "FEMALE",
      },
      stripe_id: "stripe2",
      member_id: "2",
    },
    conversationId: "conv1",
    status: "ACCEPTED",
    appointmentSlot: {
      id: "creneau1",
      startTime: "2024-03-20T14:00:00Z",
      endTime: "2024-03-20T15:00:00Z",
    },
  };

  const getMouqabalaInfos = (data: any = "") => {
    console.log(data);
    false &&
      apiGetMouqabalaInfos()
        .then((response: any) => {
          console.log(response);
          const value = response.data[0];
          handleNewIncomeMouqabalaInfos(value);
        })
        .catch((error: any) => {
          // Utiliser les données mockées en cas d'erreur
          handleNewIncomeMouqabalaInfos(mockMouqabalaInfos);
        });
  };

  useEffect(() => {
    getMouqabalaInfos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [loading, setLoading] = useState(false);

  const [openDialogAccept, setOpenDialogAccept] = useState(false);
  const handleOpenDialogAccept = () => setOpenDialogAccept(true);
  const handleCloseDialogAccept = () => {
    setOpenDialogAccept(false);
  };

  const [openDialogDeny, setOpenDialogDeny] = useState(false);
  const handleOpenDialogDeny = () => setOpenDialogDeny(true);
  const handleCloseDialogDeny = () => {
    setOpenDialogDeny(false);
  };

  const acceptMouqabala = (data: any = "") => {
    console.log({ id_mouqabala: mouqInfos?.id });

    setLoading(true);
    apiMouqabalaAccept(mouqInfos?.id || "")
      .then((response: any) => {
        setLoading(false);
        console.log(response);
        Toastify(`Mouqabala acceptée avec succès`, "success", 3000);
      })
      .catch((error: any) => {
        setLoading(false);
        Toastify(`${error?.response?.data?.message}`, "error", 5000);
      })
      .finally(() => {
        handleCloseDialogAccept();
      });
  };

  const denyMouqabala = (data: any = "") => {
    console.log({ id_mouqabala: mouqInfos?.id });

    setLoading(true);
    apiMouqabalaDeny(mouqInfos?.id || "")
      .then((response: any) => {
        setLoading(false);
        console.log(response);
        Toastify(`Mouqabala refusée avec succès`, "success", 3000);
      })
      .catch((error: any) => {
        setLoading(false);
        Toastify(`${error?.response?.data?.message}`, "error", 5000);
      })
      .finally(() => {
        handleCloseDialogDeny();
      });
  };

  const [openCreneauModal, setOpenCreneauModal] = useState(false);
  const handleOpenCreneauModal = () => setOpenCreneauModal(true);
  const handleCloseCreneauModal = () => setOpenCreneauModal(false);

  const { pathname } = useLocation();

  console.log(mouqInfos);

  /**
   *  ENd of MOUQABALA IN HEADER PART
   */

  return (
    <>
      <div className="c-header">
        <>
          <div className="mobile-header">
            <StyledBadge
              overlap="circular"
              variant="dot"
              color="primary"
              badgeContent={
                nbre_favorite_notif +
                nbre_live_notif +
                nbre_notification +
                nbre_exchange_notif +
                nbre_message_notif +
                nbre_mouqabala_notif
              }
            >
              <IconButton
                size="large"
                color="primary"
                onClick={() => {
                  dispatch(toggleSidebar());
                }}
              >
                <InlineIcon icon="heroicons-outline:menu-alt-2" />
              </IconButton>
            </StyledBadge>
            <img
              style={{ display: "none" }}
              src={require("@/assets/images/png/logo-mini.png")}
              alt="logo-mini"
              className="logo-mini"
              onClick={goToHome}
            />
            <div className="title-part">
              <h2 className="title">{title}</h2>
              <p className="subtitle">{subtitle}</p>
            </div>
            <IconButton color="info" size="large" onClick={handleOpenInfos}>
              <InlineIcon icon="entypo:info-with-circle" />
            </IconButton>
            {loading3 ? (
              <CircularProgress color="primary" size={20} />
            ) : (
              <Button
                className="btn-moderation"
                color={isModerationOpen ? "success" : "inherit"}
                onClick={handleOpenModeration}
                variant="contained"
              >
                <InlineIcon
                  icon={
                    isModerationOpen
                      ? "fa-solid:door-open"
                      : "fa-solid:door-closed"
                  }
                />
              </Button>
            )}
          </div>

          <StyledBadge
            overlap="circular"
            variant="dot"
            color="primary"
            className="rounded-square-btn "
            badgeContent={
              nbre_favorite_notif +
              nbre_live_notif +
              nbre_notification +
              nbre_exchange_notif +
              nbre_message_notif +
              nbre_mouqabala_notif
            }
          >
            <IconButton
              size="large"
              color="primary"
              onClick={() => {
                dispatch(toggleSidebar());
              }}
            >
              <InlineIcon icon="heroicons-outline:menu-alt-2" />
            </IconButton>
          </StyledBadge>
          <img
            style={{ display: "none" }}
            src={require("@/assets/images/png/logo-mini.png")}
            alt="logo-mini"
            className="logo-mini-md"
            onClick={goToHome}
          />
          <div className="title-part">
            <h2 className="title">{title}</h2>
            <p className="subtitle">{subtitle}</p>
          </div>

          <div className="btn-part">
            {loading3 ? (
              <CircularProgress color="primary" size={20} />
            ) : (
              <Button
                className="btn-moderation"
                color={isModerationReallyAvailable() ? "success" : "inherit"}
                onClick={handleOpenModeration}
                variant="contained"
              >
                Modération{" "}
                {isModerationReallyAvailable() ? "ouverte" : "fermée"}
              </Button>
            )}
          </div>

          <CustomTooltip title="À lire absolument">
            <IconButton
              color="info"
              size="medium"
              className="icon-header"
              onClick={handleOpenInfos}
            >
              <InlineIcon icon="entypo:info-with-circle" />
            </IconButton>
          </CustomTooltip>

          <CustomTooltip title="Besoin d'aide">
            <IconButton className="icon-header" onClick={handleOpenHelp}>
              <HelpOutlineRounded color="primary" />
            </IconButton>
          </CustomTooltip>

          <CustomTooltip title="Se déconnecter">
            <IconButton className="icon-header" onClick={handleClickOpenLogout}>
              <PowerSettingsNewRounded color="primary" />
            </IconButton>
          </CustomTooltip>
        </>
        {false && mouqInfos !== null && pathname !== "/profile/mouqabala" && (
          <Grow in={isMouqShow} mountOnEnter unmountOnExit>
            <div className="mouq-status">
              <div className="mouq-status__close" onClick={toggleIsMouqShow}>
                <InlineIcon icon="mingcute:close-fill" />
              </div>
              {isSender ? (
                <>
                  {/* SENDER */}

                  <div className="actor-item ">
                    <img
                      src={require(
                        "@/assets/images/png/avatar-" +
                          mouqInfos?.receiver?.gender +
                          ".png"
                      )}
                      alt="logo"
                    />
                    <div className="text-part">
                      <span className="actor-name">
                        {mouqInfos?.receiver?.username}{" "}
                      </span>
                      <span className="actor-role">
                        a accepté(e) la demande de Mouqabala
                      </span>
                    </div>
                    <small
                      style={{
                        fontSize: "1rem",
                        fontWeight: "bold",
                        color: "var(--ui-green)",
                        padding: "5px 10px",
                        borderRadius: "5px",
                        background: "rgba(117, 216, 115, 0.329)",
                      }}
                    >
                      <InlineIcon
                        icon="fluent-emoji-high-contrast:handshake"
                        color="var(--ui-green)"
                      />
                      Accepté
                    </small>

                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        marginLeft: "auto",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="text"
                        color="inherit"
                        style={{
                          width: "fit-content",
                          height: "fit-content",
                          borderRadius: "20px",
                          fontSize: "small",
                          textTransform: "capitalize",
                        }}
                        onClick={toggleIsMouqShow}
                      >
                        Fermer
                      </Button>
                      <Button
                        variant="text"
                        color="primary"
                        style={{
                          width: "fit-content",
                          height: "fit-content",
                          borderRadius: "20px",
                          fontSize: "small",
                          textTransform: "capitalize",
                        }}
                        startIcon={<InlineIcon icon="solar:eye-linear" />}
                        onClick={() => {
                          navigate(
                            routePaths.profileChildren.mouqabalaAbsolute,
                            {
                              replace: true,
                            }
                          );
                        }}
                      >
                        voir détails
                      </Button>
                      <Button
                        variant="contained"
                        color="info"
                        style={{
                          width: "fit-content",
                          height: "fit-content",
                          borderRadius: "20px",
                          fontSize: "small",
                          textTransform: "capitalize",
                        }}
                        startIcon={<InlineIcon icon="solar:calendar-outline" />}
                        onClick={handleOpenCreneauModal}
                      >
                        Choisir un créneau
                      </Button>
                    </div>
                  </div>
                  {/* End of SENDER */}
                </>
              ) : (
                <>
                  {/* RECEIVER */}
                  <div className="actor-item ">
                    <img
                      src={require(
                        "@/assets/images/png/avatar-" +
                          mouqInfos?.sender?.gender +
                          ".png"
                      )}
                      alt="logo"
                    />
                    <div className="text-part">
                      <span className="actor-name">
                        {mouqInfos?.sender?.username}{" "}
                      </span>
                      <span className="actor-role">
                        a envoyé(e) une demande de Mouqabala
                      </span>
                    </div>
                    {mouqInfos?.isNotDemande && (
                      <small
                        style={{
                          fontSize: "0.8rem",
                          fontWeight: "bold",
                          color: "var(--ui-gray)",
                          padding: "5px 10px",
                          borderRadius: "5px",
                          background: "rgba(115, 115, 115, 0.184)",
                        }}
                      >
                        En attente de paiement
                      </small>
                    )}

                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        marginLeft: "auto",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="text"
                        color="inherit"
                        style={{
                          width: "fit-content",
                          height: "fit-content",
                          borderRadius: "20px",
                          fontSize: "small",
                          textTransform: "capitalize",
                        }}
                        onClick={toggleIsMouqShow}
                      >
                        Fermer
                      </Button>
                      <Button
                        variant="text"
                        color="primary"
                        style={{
                          width: "fit-content",
                          height: "fit-content",
                          borderRadius: "20px",
                          fontSize: "small",
                          textTransform: "capitalize",
                        }}
                        startIcon={<InlineIcon icon="solar:eye-linear" />}
                        onClick={() => {
                          navigate(
                            routePaths.profileChildren.mouqabalaAbsolute,
                            {
                              replace: true,
                            }
                          );
                        }}
                      >
                        voir détails
                      </Button>
                      <Button
                        variant="contained"
                        color="success"
                        style={{
                          width: "fit-content",
                          height: "fit-content",
                          borderRadius: "20px",
                          fontSize: "small",
                          textTransform: "capitalize",
                        }}
                        startIcon={<InlineIcon icon="iconoir:check" />}
                        onClick={handleOpenDialogAccept}
                      >
                        Accepter
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        style={{
                          width: "fit-content",
                          height: "fit-content",
                          borderRadius: "20px",
                          fontSize: "small",
                          textTransform: "capitalize",
                        }}
                        startIcon={<InlineIcon icon="iconoir:cancel" />}
                        onClick={handleOpenDialogDeny}
                      >
                        Refuser
                      </Button>
                    </div>
                  </div>
                  {/* End of RECEIVER */}
                </>
              )}
            </div>
          </Grow>
        )}
      </div>

      <CModalInfosZawaj open={openInfos} closeModal={handleCloseInfos} />
      <CModal
        open={openHelp}
        type="aide"
        onClose={handleCloseHelp}
        closeClick={handleCloseHelp}
      />
      <CModal
        open={openModeration}
        type="moderation"
        onClose={handleCloseModeration}
        closeClick={handleCloseModeration}
        moderation_socket={moderation_socket}
        is_moderation_suspend={!isModerationReallyAvailable()}
      />
      <Dialog
        open={openLogout}
        onClose={handleCloseLogout}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Déconnexion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Vous êtes sur le point de vous déconnecter. Êtes-vous sûr(e) de
            vouloir le faire ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseLogout}>Annuler</Button>
          <Button onClick={logout} autoFocus>
            Déconnecter
          </Button>
        </DialogActions>
      </Dialog>

      {/* ACCEPT MOUQABALA  DIALOG PART */}
      <Dialog
        open={openDialogAccept}
        onClose={handleCloseDialogAccept}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Acceptation de mouqabala"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Attention vous êtes sur le point d'
            <b>accepter la mouqabala</b> avec{" "}
            <b>{mouqInfos?.sender?.username}</b>.
            {false && (
              <>
                La Mouqabala se déroulera pendant
                <b style={{ color: "var(--ui-medium)" }}>
                  {" "}
                  {mouqInfos?.mouqabala_duration}{" "}
                </b>{" "}
                de{" "}
                <b style={{ color: "var(--ui-medium)" }}>
                  {mouqInfos?.mouqabala_start_time}
                </b>{" "}
                à{" "}
                <b style={{ color: "var(--ui-medium)" }}>
                  {mouqInfos?.mouqabala_end_time}
                </b>{" "}
                le{" "}
                <b style={{ color: "var(--ui-medium)" }}>
                  {mouqInfos?.mouqabala_date}
                </b>{" "}
              </>
            )}
            <br />
            <br />
            <p className="spe">
              {" "}
              Êtes-vous sûr(e) de vouloir accepter la mouqabala ?{" "}
            </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {loading ? (
            <LoaderMini />
          ) : (
            <>
              <Button onClick={handleCloseDialogAccept}>Non, Fermer</Button>
              <Button
                onClick={() => {
                  acceptMouqabala("");
                }}
                autoFocus
              >
                Oui, Accepter
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
      {/* Ennd of ACCEPT MOUQABALA   DIALOG PART */}

      {/* DENY MOUQABALA  DIALOG PART */}
      <Dialog
        open={openDialogDeny}
        onClose={handleCloseDialogDeny}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Refus de mouqabala"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Attention vous êtes sur le point de
            <b>refuser la mouqabala</b> avec{" "}
            <b>{mouqInfos?.sender?.username}</b>. Vous perdrez donc
            l'opportunité qui vous était donnée de vous voir avec{" "}
            <b>{mouqInfos?.sender?.username}</b> pendant{" "}
            <b style={{ color: "var(--ui-medium)" }}>
              {" "}
              {mouqInfos?.mouqabala_duration}{" "}
            </b>{" "}
            de{" "}
            <b style={{ color: "var(--ui-medium)" }}>
              {mouqInfos?.mouqabala_start_time}
            </b>{" "}
            à{" "}
            <b style={{ color: "var(--ui-medium)" }}>
              {mouqInfos?.mouqabala_end_time}
            </b>{" "}
            le{" "}
            <b style={{ color: "var(--ui-medium)" }}>
              {mouqInfos?.mouqabala_date}
            </b>{" "}
            .
            <br />
            <br />
            <p className="spe">
              {" "}
              Êtes-vous sûr(e) de vouloir refuser la mouqabala ?{" "}
            </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {loading ? (
            <LoaderMini />
          ) : (
            <>
              <Button onClick={handleCloseDialogDeny}>Non, Fermer</Button>
              <Button
                onClick={() => {
                  denyMouqabala("");
                }}
                autoFocus
              >
                Oui, Refuser
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
      {/* Ennd of DENY MOUQABALA   DIALOG PART */}

      {/* CRENEAU MODAL */}
      {openCreneauModal && (
        <ModalCreneau
          open={openCreneauModal}
          onClose={handleCloseCreneauModal}
          closeClick={handleCloseCreneauModal}
          currentExchange={currentExchange}
          receiver={receiverFromExchangeRole}
          mouqabala_id={mouqInfos?.id!?.toString()}
        />
      )}
      {/* End of CRENEAU MODAL*/}
    </>
  );
};

export default Header;
